export const metadata = {
  title: 'Aktuellt',
  routes: {
    '/oversikt': {
      label: 'Översikt'
    }
  }
};